import bizTable from '@/biz/bizTable.mjs'

export default bizTable('/basDatabaseDriver/listEnableBasDatabaseDriver', 'pkid')
